import { render, staticRenderFns } from "./PopupZoomImage.vue?vue&type=template&id=02b6b001&"
import script from "./PopupZoomImage.vue?vue&type=script&lang=ts&"
export * from "./PopupZoomImage.vue?vue&type=script&lang=ts&"
import style0 from "./PopupZoomImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports